import React from 'react'
import { Portal } from '@mui/material'
import { useOtherTrayItemsLogic } from './OtherTrayItems.logic'
import { useOtherTrayItems } from './OtherTrayItems.context'
import { KWires } from 'components/KWires'
import Modal from 'components/molecules/Modal/Modal'
import CloseIcon from '@mui/icons-material/Close'
import Button from 'components/molecules/Button/Button'
import './OtherTrayItems.scss'

interface OtherTrayItemsProps {
  trayType: string
}

export const OtherTrayItems: React.FC<OtherTrayItemsProps> = ({ trayType }) => {
  const { otherItems } = useOtherTrayItemsLogic(trayType)
  const { selectedItems, addItem, removeItem, modalOpen, setModalOpen } =
    useOtherTrayItems(otherItems)

  const otherItemOptions = otherItems.map((item) => ({
    label: item.label || item.device_description,
    value: item.device_id,
    description: item.device_description,
    count: item.count || 999999,
  }))

  if (otherItems.length === 0) {
    return null
  }

  return (
    <Portal>
      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        className="other-items-modal"
      >
        <div className="other-tray-items-modal">
          <button
            className="other-tray-items-modal__close-button"
            onClick={() => setModalOpen(false)}
            aria-label="Close modal"
          >
            <CloseIcon />
          </button>
          <div className="other-tray-items-modal__content">
            <KWires
              items={otherItemOptions}
              selectedItems={selectedItems.map((item) => ({
                id: item.device_id,
                name: item.device_description,
                count: item.count,
              }))}
              onAddItem={addItem}
              onRemoveItem={removeItem}
            />
            <div className="other-tray-items-modal__footer">
              <Button
                variant="contained"
                color="primary"
                className="other-tray-items-modal__done-button"
                onClick={() => setModalOpen(false)}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </Portal>
  )
}
